export default __webpack_public_path__ + "static/logo_text-1cd3118dc76a221056eadb07e0c2b9f6.svg";